import React, { PropsWithChildren } from 'react'

import { Body } from '../Content'
import { Label } from '../Form'
import { flat } from 'utils'

export interface IAttributeProps {
  secondary?: boolean
  label: string
  value?: string | string[] | null
  noTruncate?: boolean
}

export const Attribute: React.FC<PropsWithChildren<IAttributeProps>> = ({
  label,
  children,
  secondary = false,
  value = [],
  noTruncate = false,
}) => (
  <p className="py-2 w-full m-0 box-border">
    <Label secondary={secondary}>{label}</Label>
    {flat([value]).map((v, i) =>
      v ? (
        <Body
          key={`${label}${i}`}
          marginClassNames="m-0"
          className={noTruncate ? 'break-words' : 'truncate'}
        >
          {v}
        </Body>
      ) : null
    )}
    {children ? <Body marginClassNames="m-0">{children}</Body> : null}
  </p>
)
